import React from 'react'
// import classNames from 'classnames'
import { Config } from '../constants'

import { LanguageToggle } from './LanguageToggle'
import { LanguageContext } from '../contexts'
import { LanguageDictionary } from '../language'
import { Login } from './Login'

import logoOscia from './logo-OSCIA.png'
import logoEnglishCap from './logo-CAP-EN.jpg'
import logoFrenchCap from './logo-CAP-FR.jpg'

import './Header.scss'

const logoCAP: LanguageDictionary<string> = {
	English: logoEnglishCap, 
	French: logoFrenchCap
}

export function Header() {
	const { localizedText, language } = React.useContext(LanguageContext)

	// const headerClassName = classNames('level', Config.Environment)

	// TFS#5725: we removed the original header image 
	// const headerImage = <img src={logoCAP[language]} className='cap header-logo' alt={localizedText.CapFull} title={localizedText.CapFull} />

	// and moving oscia logo over to replace it
	const headerImage = <img src={logoOscia} className='oscia header-logo' alt={localizedText.OsciaFull} title={localizedText.OsciaFull} />

	return (
		<header className='columns'>
			<div className='column'>
				{headerImage}
			</div>

			<div className='column has-text-centered'>
				<h1 className='title is-2 has-text-primary'>{localizedText.Workshops}</h1>
			</div>

			<div className='column has-text-right is-clearfix'>
				<LanguageToggle />
				<Login />
			</div>
		</header>
	)
}

export default Header
